<template lang='pug'>
.display-state(:class='options.state' @click='removeIfFailed')
	component(
		v-if='options.component'
		:is='options.component'
		:options='options.props'
	)
	p(v-else)
		span.header(v-if='options.header') {{ options.header }}
		span {{ options.message }}
</template>

<script>
export default {
	name : 'display-state',

	props : {
		options : {
			type : Object,
		}
	},

	methods : {

		removeIfFailed() {
			const { index, state } = this.options;

			if ( state !== 'failed' ) {
				return;
			}

			this.$store.dispatch( 'removeDisplayState', index );
		}

	}
};
</script>

<style lang='scss'>
@import '../assets/scss/variables';

.display-state {
	width: 100%;
	padding: 10px;
	animation: slide-in 0.25s 1 ease;
	animation-fill-mode: forwards;
	transition: background 0.2s ease, color 0.2s ease;
	display: flex;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
	border-left: 5px solid $darkGrey;
	background: lighten( $color-primary, 15% );
	box-shadow: $defaultBoxShadow;
	width: fit-content;

	p {
		font-size: 16px;
		color: white;

		span {
			display: inline;
			color: inherit;

			&.header {
				margin-right: 5px;
				font-weight: 600;
			}
		}
	}

	&.loading {
		background: white;
		border-left: 5px solid $grey;

		p {
			color: $grey;
		}
	}

	&.failed {
		background: $red;
		border-left: 5px solid darken( $red, 10% )!important;
		cursor: pointer;

		p {
			color: white;
		}
	}

	&.succeeded {

		p {
			color: white;
		}
	}
}

@keyframes slide-in {
	0% {
		transform: translate3d(-100%,0,0);
	}

	100% {
		transform: translate3d(0,0,0);
	}
}
</style>
